import { h } from 'preact';
import { Hover } from 'utilities/dom';
import { COMPOSITION_TYPES } from 'constants/annotations';
import { focusable, accessible } from 'utilities/accessibility';

const { CONTENT_EXPLORER } = COMPOSITION_TYPES;
const MAX_CONTENT_LENGTH = 72;

export const SearchBar = props => {
    const searchAttrs = {
            type: 'text',
            className: 'search-input',
            placeholder: props.placeholder,
            onKeyUp: props.onKeyUp,
            onFocus: props.onFocusChange.bind(null, 'focus'),
            style: props.getElementStyles(CONTENT_EXPLORER.SEARCH_INPUT),
            role: 'searchbox',
            value: props.searchValue,
            'aria-label': props.placeholder,
            ...focusable
        },
        matchedBookmarks = props.results.bookmarks.length,
        matchedCaptions = props.results.captions.length,
        macthedAnnotations = props.results.annotations.length,
        hasSearch = !!props.searchValue;
    
    return (
        <nav class="search-bar" data-focused={ props.focused } style={ props.getElementStyles(CONTENT_EXPLORER.SEARCH_BAR) } data-has-search={ hasSearch }>
            <input { ...searchAttrs }/>

            {
                hasSearch ?
                    (
                        <span data-search-results>
                            <ul key="search-bar-results"  style={ props.getElementStyles(CONTENT_EXPLORER.LIST) } role="menu" aria-label="Search Results">
                                <lh>Bookmarks</lh>
                                {
                                    matchedBookmarks ? searchResults(props.results.bookmarks, props) : <li className="zero-results">No Results</li>
                                }
                            </ul>
                            <ul>
                                <lh>Captions</lh>
                                {
                                    matchedCaptions ? searchResults(props.results.captions, props) : <li className="zero-results">No Results</li>
                                }
                            </ul>
                            <ul>
                                <lh>Annotations</lh>
                                {
                                    macthedAnnotations ? searchResults(props.results.annotations, props) : <li className="zero-results">No Results</li>
                                }
                            </ul>
                        </span>

                    ) :
                    (
                        <ul key="search-bar-bookmarks" data-bookmarks style={ props.getElementStyles(CONTENT_EXPLORER.LIST) } role="menu" aria-label="Search Results">
                            { list(props.bookmarks, props) }
                            <ListExpander { ...props } />
                        </ul>
                    )
            }
        </nav>
    );
}

export const searchResults = (items, props) => {
    const listHash = items.map(l => l.content.slice(0, 5)).join('');

    return items.map((r, i) => {
        const onClick = () => props.goToTime(r.start),
            attrs = {
                onClick,
                key: `${listHash}-${i}`,
                style: props.getElementStyles(CONTENT_EXPLORER.LIST_ITEM),
                ...accessible(onClick)
            };

        return (
            <li { ...attrs }>
                { r.content.length > MAX_CONTENT_LENGTH ? `${r.content.slice(0, MAX_CONTENT_LENGTH)}...` : r.content }
            </li>
        )
    });
}

export const list = (items, props, max) => {
    const trimmedResults = items.slice(0, max || props.maxResults),
        listHash = items.map(l => l.content.slice(0, 5)).join('');

    return trimmedResults.map((r, i) => {
        const onClick = () => props.goToTime(r.start),
            attrs = {
                onClick,
                key: `${listHash}-${i}`,
                style: props.getElementStyles(CONTENT_EXPLORER.LIST_ITEM),
                ...accessible(onClick)
            },
            showPanel = e => {
                if (e) {
                    e.stopPropagation();
                }
                
                props.onSelectItem(r);

                if (cancelFn) {
                    cancelFn();
                }
            },
            cancelHoverProvider = fn => cancelFn = fn;

        let cancelFn;

        return (
            <Hover key={ `${attrs.key}-hover` } onElapsed={ r.description && showPanel  } cancelHoverProvider={ cancelHoverProvider }>
                <li { ...attrs }>
                    { r.content }
                </li>
            </Hover>
        )
    });
}; 

export const ListExpander = props => {
    if (props.maxResults < props.results.bookmarks.length) {
        return <li className="expander" aria-label="Expand results" onClick={ props.onExpandResults } { ...accessible(props.onExpandResults) }>...</li>;
    }

    return null;
}